import { createContext, useContext, useState } from "react";

/* ================= CONTEXT ================= */

const EventRequirementContext = createContext(null);

/* ================= PROVIDER ================= */

export const EventRequirementProvider = ({ children }) => {
  const [role, setRole] = useState(""); // planner | performer | crew

  const [basicEvent, setBasicEvent] = useState({});
  const [planner, setPlanner] = useState({});
  const [performer, setPerformer] = useState({});
  const [crew, setCrew] = useState({});

  const resetEventRequirement = () => {
    setRole("");
    setBasicEvent({});
    setPlanner({});
    setPerformer({});
    setCrew({});
  };

  return (
    <EventRequirementContext.Provider
      value={{
        // role
        role,
        setRole,

        // common event
        basicEvent,
        setBasicEvent,

        // role specific
        planner,
        setPlanner,
        performer,
        setPerformer,
        crew,
        setCrew,

        // utils
        resetEventRequirement,
      }}
    >
      {children}
    </EventRequirementContext.Provider>
  );
};

/* ================= HOOK ================= */

export const useEventRequirement = () => {
  const context = useContext(EventRequirementContext);

  if (!context) {
    throw new Error(
      "useEventRequirement must be used inside EventRequirementProvider",
    );
  }

  return context;
};
